export function mapIncludes(needle, haystack) {
    for (const [k, v] of haystack) {
        if (v === needle) {
            return true;
        }
    }
    return false;
}

export function mapValuesToArray(map) {
    const arr = [];
    for (const [k, v] of map) {
        arr.push(v);
    }
    return arr;
}

export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
